export default __webpack_public_path__ + "static/media/crowd.86fd6cd1.jpg";